import type {
  MenuListComponentProps as ReactSelectMenuListProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { useSelectStyles } from '../SelectStylesContext';

export type MenuListProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectMenuListProps<OptionType, IsMulti> & {
  innerProps?: BoxProps;
};

export const MenuList = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  maxHeight,
  innerProps,
  innerRef,
}: MenuListProps<OptionType, IsMulti>) => {
  const { menuList: menuListStyles } = useSelectStyles();

  return (
    <Box {...innerProps} ref={innerRef} __css={menuListStyles} maxH={maxHeight}>
      {children}
    </Box>
  );
};
